export default __webpack_public_path__ + "static/media/desenvolvimento_da_linguagem_matematica.03ee8e85.pdf";